import React, { useState } from 'react';
import { Card, Space, Switch, InputNumber, Typography, Alert } from 'antd';
import OSSFileUploader from '../../components/OSSFileUploader';

const { Title, Text } = Typography;

/**
 * 队列上传演示页面
 */
const QueueUploadDemo = () => {
  const [queueEnabled, setQueueEnabled] = useState(true);
  const [maxConcurrent, setMaxConcurrent] = useState(3);

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>队列上传功能演示</Title>
      
      <Alert
        message="当前上传机制说明"
        description={
          <div>
            <p><strong>默认行为：</strong>同时上传所有选中的文件（并行上传）</p>
            <p><strong>队列控制：</strong>限制同时上传的文件数量，其他文件排队等待</p>
            <p><strong>优势：</strong>避免网络拥塞，提升整体上传稳定性</p>
          </div>
        }
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Card title="上传控制面板" style={{ marginBottom: 24 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Space>
            <Text>启用队列控制:</Text>
            <Switch 
              checked={queueEnabled} 
              onChange={setQueueEnabled}
              checkedChildren="开启"
              unCheckedChildren="关闭"
            />
          </Space>
          
          {queueEnabled && (
            <Space>
              <Text>最大同时上传数:</Text>
              <InputNumber
                min={1}
                max={10}
                value={maxConcurrent}
                onChange={setMaxConcurrent}
              />
            </Space>
          )}
          
          <Text type="secondary">
            {queueEnabled 
              ? `当前设置：最多同时上传 ${maxConcurrent} 个文件，其他文件将排队等待`
              : '当前设置：所有文件同时上传（并行模式）'
            }
          </Text>
        </Space>
      </Card>

      <OSSFileUploader
        title="文件上传区域"
        multiple={true}
        showProgress={true}
        showUploadList={true}
        maxFileSize={5 * 1024 * 1024 * 1024} // 5GB
        accept="*/*"
        onUploadSuccess={(file) => {
          console.log('上传成功:', file);
        }}
        onUploadError={(error, file) => {
          console.error('上传失败:', error, file);
        }}
      />
    </div>
  );
};

export default QueueUploadDemo;
